module.exports = __webpack_public_path__ + "static/media/penaltyShootout.c18193cb.svg";